// extracted by mini-css-extract-plugin
export var layoutContainer = "_3o-0";
export var layoutContainerOpen = "_3o-5";
export var layoutContainerResizing = "_3o-1";
export var mainContent = "_3o-2";
export var resizeDivider = "_3o-3";
export var slidePanel = "_3o-4";